import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = { class: "dialog-footer" }

import { ref, computed, nextTick, watch } from 'vue';
import { ElMessage, ElForm, ElFormItem, ElInput, ElDialog, ElButton } from 'element-plus';
import { getUserProfile, updateUserProfile } from '@/user/api/userApi';
import { useStore } from 'vuex'; // 导入useStore

interface Props {
  modelValue: boolean;
}

interface Emits {
  (e: 'update:modelValue', value: boolean): void;
  (e: 'updated', profile: any): void;
  (e: 'close'): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EditProfileModal',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "updated", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const store = useStore(); // 初始化store

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

const formRef = ref<InstanceType<typeof ElForm>>();
const loading = ref(false);
const submitting = ref(false);
const profileForm = ref({
  name: '',
  email: '',
  phone: '',
  signature: ''
});

// 表单验证规则
const rules = {
  name: [
    { required: true, message: '请输入用户名', trigger: 'blur' },
    { min: 2, max: 20, message: '用户名长度应在2-20个字符之间', trigger: 'blur' }
  ],
  email: [
    { required: true, message: '请输入邮箱地址', trigger: 'blur' },
    { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
  ],
  phone: [
    { required: true, message: '请输入电话号码', trigger: 'blur' },
    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
  ],
  signature: [
    { max: 100, message: '个人介绍不能超过100个字符', trigger: 'blur' }
  ]
};

// 加载用户资料
const loadUserProfile = async () => {
  try {
    loading.value = true;
    const response = await getUserProfile();
    
    if (response.data.code === 1) {
      const data = response.data.data;
      profileForm.value = {
        name: data.name || '',
        email: data.email || '',
        phone: data.phone || '',
        signature: data.signature || ''
      };
    } else {
      throw new Error(response.data.msg || '获取用户资料失败');
    }
  } catch (error: any) {
    console.error('获取用户资料失败:', error);
    ElMessage.error(error.message || '获取用户资料失败');
  } finally {
    loading.value = false;
  }
};

// 提交表单
const submitForm = async () => {
  if (!formRef.value) return;
  
  // 验证表单
  const valid = await formRef.value.validate().catch(() => false);
  if (!valid) return;
  
  try {
    submitting.value = true;
    
    const response = await updateUserProfile(profileForm.value);
    
    if (response.data.code === 1) {
      ElMessage.success('个人资料更新成功！');
      
      // 更新成功后，获取最新的用户资料并更新store
      try {
        const profileResponse = await getUserProfile();
        
        if (profileResponse && profileResponse.data && profileResponse.data.code === 1) {
          // 更新用户信息到store
          store.commit('SET_USER_INFO', profileResponse.data.data);
          console.log('用户资料已更新到store');
        } else {
          console.error('获取用户资料失败:', profileResponse?.data?.msg || '未知错误');
        }
      } catch (error) {
        console.error('获取最新用户资料时发生错误:', error);
      }

      emit('updated', profileForm.value);
      handleClose();
    } else {
      throw new Error(response.data.msg || '更新失败');
    }
  } catch (error: any) {
    console.error('更新个人资料失败:', error);
    ElMessage.error(error.message || '更新个人资料失败');
  } finally {
    submitting.value = false;
  }
};

// 关闭对话框
const handleClose = () => {
  emit('close');
  nextTick(() => {
    if (formRef.value) {
      formRef.value.clearValidate();
    }
  });
};

// 监听弹窗显示状态变化

watch(dialogVisible, (newValue) => {
  if (newValue) {
    loadUserProfile();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElDialog), {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialogVisible).value = $event)),
    title: "编辑个人资料",
    width: "500px",
    "close-on-click-modal": false,
    "before-close": handleClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_unref(ElButton), { onClick: handleClose }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(ElButton), {
          type: "primary",
          onClick: submitForm,
          loading: submitting.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(submitting.value ? '保存中...' : '保存'), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, "加载中..."))
        : (_openBlock(), _createBlock(_unref(ElForm), {
            key: 1,
            model: profileForm.value,
            rules: rules,
            ref_key: "formRef",
            ref: formRef,
            "label-width": "80px",
            style: {"padding":"10px 0"}
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElFormItem), {
                label: "用户名",
                prop: "name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElInput), {
                    modelValue: profileForm.value.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((profileForm.value.name) = $event)),
                    placeholder: "请输入用户名",
                    maxlength: "20",
                    "show-word-limit": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(ElFormItem), {
                label: "邮箱",
                prop: "email"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElInput), {
                    modelValue: profileForm.value.email,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((profileForm.value.email) = $event)),
                    placeholder: "请输入邮箱"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(ElFormItem), {
                label: "电话",
                prop: "phone"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElInput), {
                    modelValue: profileForm.value.phone,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((profileForm.value.phone) = $event)),
                    placeholder: "请输入电话号码"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(ElFormItem), {
                label: "个人介绍",
                prop: "signature"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElInput), {
                    modelValue: profileForm.value.signature,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((profileForm.value.signature) = $event)),
                    type: "textarea",
                    rows: 4,
                    placeholder: "请输入个人介绍",
                    maxlength: "100",
                    "show-word-limit": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})